
























































import Vue from 'vue'
import moment from 'moment/moment'
import request from '@/utils/request'
import config from '@/utils/config'
import changeUnit from '@/utils/changeUnit'
import recommend from '@/components/component/recommend.vue'
import totalReadCount from '@/components/component/totalReadCount.vue'
const classifyArr = [
    {
        name: '分类',
        listArr: [],
    }, {
        name: '排行',
        listArr: [
            {
                name: '全部',
                id: '-1',
            }, {
                name: '最新',
                id: '0',
            }, {
                name: '最热',
                id: '1',
            },
        ],
    },
]
export default Vue.extend({
    components: {
        recommend,
        totalReadCount,
    },
    props: {
        menuItem: {
            type: Object,
        },
    },
    watch: {
        menuItem() {
            // console.log(this.menuItem)
            // this.getClassifyArr()
            // this.itemIdArr = []
            // this.pageNum = 1
            // this.pageSize = 6
        },
    },
    data() {
        return {
            barId: '10',
            imgUrl: config.imgUrl,
            imageData: [],
            classifyArr,
            itemIdArr: [] as any,
            pageNum: 1,
            pageSize: 6,
            data: {
                total: 0,
                list: [],
            },
            recommendData: [],
        }
    },
    created() {
        this.getClassifyArr()
        this.getRecommendData()
    },
    methods: {
        getClassifyArr() {
            request.get(`/api/cultural/column_rest/children_list/${this.barId}`)
            .then((result) => {
                // console.log(result)
                if (result) {
                    this.imageData = result.images
                }
                if (result.children) {
                    const arr = [] as any
                    result.children.map((e: any) => {
                        arr.push({name: e.name, id: e.id})
                    })
                    arr.unshift({
                        name: '全部',
                        id: this.barId,
                    })
                    this.classifyArr[0].listArr = arr
                    this.classifyArr.map((e) => {
                        this.itemIdArr.push(e.listArr[0].id)
                    })
                    this.getData()
                }
            })
        },
        classifyQuery(indexClass: any, item: any) {
            this.$set(this.itemIdArr, indexClass, item.id)
            this.pageNum = 1
            this.getData()
        },
        changPageNum(num: any) {
            this.pageNum = num
            this.getData()
        },
        getData() {
            const params = {
                columnId: this.itemIdArr[0],
                sort: this.itemIdArr[1] === '-1' ? '0' : this.itemIdArr[1],
            } as any
            params.pageNum = this.pageNum
            params.pageSize = this.pageSize
            // console.log(params)
            request.get('/api/cultural/article_rest/page', params)
            .then((result) => {
                // console.log(result.list)
                if (result) {
                    result.list.map((e: any) => {
                        e.time = moment(e.createTime).format('YYYY-MM-DD')
                        e.year = moment(e.createTime).format('YYYY')
                        e.month = moment(e.createTime).format('MM')
                        e.day = moment(e.createTime).format('DD')
                    })
                    this.data = result
                } else {
                    this.data.total = 0
                    this.data.list = []
                }
            }).catch((error) => {
                console.log(error)
                this.data.total = 0
                this.data.list = []
            })
        },
        checkDetail(detailId: any) {
            this.$router.push({
                path: '/detailsPage',
                query: {
                    barId: this.barId,
                    detailId,
                },
            })
        },
        getRecommendData() {
            // console.log(this.barId)
            const params = {
                columnId: this.barId,
            }
            request.get(`/api/cultural/article_rest/relevant_list`, params)
            .then((result) => {
                // console.log(result)
                result.map((e: any) => {
                    e.time = moment(e.createTime).format('YYYY-MM-DD')
                })
                this.recommendData = result
            })
        },
    },
    filters: {
        getChangeUnit(value: any) {
            return changeUnit.changeUnit(value)
        },
    },
})
